import { useFormContext } from 'react-hook-form';

import { Stack, Button, useTheme } from '@mui/material';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useTranslate } from 'src/locales';

import { useChannelContext } from '../hooks';

type RenderPrevNextBtnProps = {
  isNextDisabled?: boolean;
  onNext?: () => void;
};

export const RenderPrevNextBtn = ({ isNextDisabled, onNext }: RenderPrevNextBtnProps) => {
  const theme = useTheme();
  const { t } = useTranslate('translation');
  const { onChangeStep, activeStep, steps } = useChannelContext();

  const formContext = useFormContext();

  const isLastStep = activeStep === steps.length - 1;
  const isFirstStep = activeStep === 0;

  const handleNext = () => {
    if (onNext) {
      onNext();
      return;
    }

    if (!formContext) {
      onChangeStep('next');
    }
  };

  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="end" sx={{ gap: 1 }}>
      {!isLastStep && (
        <Button
          variant="outlined"
          color="inherit"
          {...(isFirstStep
            ? { component: RouterLink, href: paths.channel.root }
            : { onClick: () => onChangeStep('back') })}
        >
          {t('PREVIOUS')}
        </Button>
      )}

      <Stack direction="row" spacing={2}>
        <Button disabled={isNextDisabled} variant="outlined" type="submit" onClick={handleNext}>
          {isLastStep ? t('FINISH') : t('NEXT')}
        </Button>
      </Stack>
    </Stack>
  );
};
